import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PlaygroundBase } from './Playground'

import { playgroundActions } from 'reduxModules/actions/PlaygroundActions'
import { allBookingsSelector, isCompleteSelector } from 'reduxModules/selectors/PlaygroundSelectors'

const mapStateToProps = createStructuredSelector({
  bookings: allBookingsSelector,
  isComplete: isCompleteSelector,
})

const mapDispatchToProps = {
  getAllBookings: playgroundActions.getAllBookings
}

export const Playground = connect(mapStateToProps, mapDispatchToProps)(PlaygroundBase)


// WEBPACK FOOTER //
// ./src/components/Playground/index.js